import './styles/index.ts';
import Header from './components/Header';
import AppHeader from './components/AppHeader';
import {getRenderNode, getPageType, isMobile, getUrlParam, removeCloudHeader} from './utils/util';

const pageType = getPageType();
const linkFrom = getUrlParam('linkFrom');
// 判断界面是否已经存在预设的配置项中，如果存在再执行下面的自动实例化逻辑
if (pageType && pageType !== 'DEFAULT') {
    const renderNode = getRenderNode();
    // 判断url有linkFrom标识，展示云的头
    if (renderNode && (!linkFrom || linkFrom !== 'cloud')) {
        if (isMobile()) {
            new AppHeader({
                el: renderNode,
                pageType
            });
        } else {
            new Header({
                el: renderNode,
                pageType
            });
        }
        removeCloudHeader('.header-cloud');
    }
}
window['QifuHeader'] = Header;

let head = document.querySelector('head');
let script = document.createElement('script');
script.type = 'text/javascript';
script.src = 'https://bce.bdstatic.com/lib/@baiducloud/fe-qifu-common-sdk/@latest/login-sdk.js';

let link = document.createElement('link');
link.rel = 'stylesheet';
link.type = 'text/css';
link.href = 'https://bce.bdstatic.com/lib/@baiducloud/fe-qifu-common-sdk/@latest/static/css/main.css';
head.insertBefore(script, head.firstChild);
head.insertBefore(link, head.firstChild);

// 获取cookies值
function getCookie(name) {
    const matches = String(document.cookie).match(new RegExp('(?:^|)' + name + '(?:(?:=([^;]*))|;|$)'));
    let ret = '';
    if (matches) {
        ret = decodeURIComponent(matches[2]);
    }
    return ret;
}

// 判断是否登录
function checkLogin() {
    return Boolean(getCookie('bce-user-info'));
}

function handlerClick() {
    // @ts-ignore
    let [, verifyHandler] = window.loginSdk.checkActivateUser({});
    verifyHandler().then().catch(err => console.log(err));
}

window.onload = () => {
    if (!checkLogin()) {
        // 登录按钮
        let loginContainer = document.getElementById('loginContainer');
        loginContainer.addEventListener('click', handlerClick);

        // 注册按钮
        let registerContainer = document.getElementById('registerContainer');
        registerContainer.addEventListener('click', handlerClick);
    }
}
